<nav class="navbar navbar-expand-lg navColor navbar-light bg-light fixed-top navBackground" id="header"
    data-toggle="affix">
    <div class="container-fluid">
        <a class="navbar-brand" href="#"><img style="outline: none;box-shadow: none; cursor: pointer;"
                [routerLink]="['/']" src="assets/ducatus_property _logo.png" class="img-fluid headerLogo"
                alt="logo"></a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse float-right" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            </ul>
            <form class="d-flex navBarLinks">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li class="nav-item">
                        <a class="nav-link navFont" aria-current="page" href="#">Home</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link navFont" [routerLink]="['/listing']" (click)="movePageTop()">Property
                            Listings</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link navFont" [routerLink]="['/contact']" (click)="movePageTop()">Contact Us</a>
                    </li>
                    <li class="nav-item">
                        <div class="btn-group ">
                            <button class="btn btn-default navFont dropdown-toggle d-flex" type="button"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                <div class="ml-5" *ngIf="selected_currency != 'Convert Currency'" >
                                    <img style="width: 25px; height: 25px; margin-top: -5px;" *ngIf="selected_currency_img"
                                        src="{{serverUrl}}{{selected_currency_img}}" />
                                </div>
                                {{selected_currency}}
                            </button>
                            <div class="dropdown-menu">
                                <a *ngFor="let item of c_type" (click)="selectedAsset(item)"
                                    class="dropdown-item navFont" style="cursor: pointer;"> <img
                                        style="width: 25px; height: 25px;" src="{{serverUrl}}{{item.currency_icon}}" />
                                    {{item.currency}}</a>
                            </div>
                        </div>
                    </li>
                </ul>
            </form>
        </div>
    </div>
</nav>